/**
 * Flips the given steps to completed. Returns `undefined` when every step was already
 * completed, so callers can skip a pointless shop-meta write.
 */
export const mergeSetupGuideStatuses = <
  TStatuses extends Partial<Record<keyof TStatuses, boolean>>,
>(
  statuses: TStatuses,
  keys: (keyof TStatuses)[],
): TStatuses | undefined => {
  const newStatuses = { ...statuses };

  let shouldUpdate = false;
  keys.forEach((key) => {
    if (newStatuses[key]) return;

    // The constraint pins every value to boolean, but TS cannot narrow the generic indexed access.
    newStatuses[key] = true as TStatuses[keyof TStatuses];
    shouldUpdate = true;
  });

  if (!shouldUpdate) return;

  return newStatuses;
};
